import React from 'react';
import { Flex, Typography } from '@banhala/ui-kit';

export const PocHeader = () => {
  return (
    <Flex.Column flex={1} gap={8} margin={{ top: 16 }}>
      <Typography type="h2" color="content_primary">
        상담 그룹을 등록하고{'\n'}더 쉽게 문의하세요
      </Typography>
      <Typography type="body1" color="content_secondary">
        상담 그룹으로 등록되었다면,{'\n'}본인이 아니더라도 안내를 받을 수 있어요
      </Typography>
    </Flex.Column>
  );
};
